const $ = jQuery;

module.exports = class {

	#cache = new Map();
    #searchTerm = '';
	#sessionToken = '';

	config = {
		matchingAjax: {
			url: '/wp-json/lumeris/v1/geomatics/address/matching',
			method: 'GET'
		},
		detailsAjax: {
			url: '/wp-json/lumeris/v1/geomatics/address/details',
		},
		delay: 500,
        minimumLength: 3,
		optionsCallback: null,
        cache: true,
        cacheLimit: 20
	};

	#$form;
    #$streetAddressField;
    #$streetAddress2Field;
    #$cityField;
    #$stateField;
	#$zipCodeField;
	#$dropdown;
	#$list;

	

	constructor(args) {
		this.#$form = args.$form ?? null;

		if (!this.$form || this.$form.length === 0) {
			return null;
		}

		this.#$streetAddressField = args.$streetAddressField ?? null;
		this.#$streetAddress2Field = args.$streetAddress2Field ?? null;
		this.#$cityField = args.$cityField ?? null;
		this.#$stateField = args.$stateField ?? null;
		this.#$zipCodeField = args.$zipCodeField ?? null;

		this.#$dropdown = args.$dropdown ?? $('<div class="address-autocomplete-dropdown"></div>');
		this.#$list = args.$list ?? $('<ul class="address-autocomplete-list"></ul>');

		if (typeof args.$list == 'undefined') {
			this.#$dropdown.append(this.#$list);
		}

		this.#sessionToken = this.generateSessionToken();

		this.bind();
	}


	bind() {
		this.$streetAddressField.on('input', (event) => { this.onStreetAddressInput(event); });
        this.$streetAddressField.on('focus', (event) => { this.onStreetAddressFocus(event); });
        this.$streetAddressField.on('keypress', (event) => { this.onStreetAddressKeypress(event); });
	}

	bindListOptions() {
        this.$list.find('a').on('click', (event) => { this.onListOptionClick(event); });
    }

	get searchTerm() {
        return this.#searchTerm;
    }

    get cache() {
        return this.#cache;
    }

	get sessionToken() {
		return this.#sessionToken;
	}

	get $form() {
		return this.#$form;
	}

	get $streetAddressField() {
		return this.#$streetAddressField;
	}

	get $streetAddress2Field() {
		return this.#$streetAddress2Field;
	}

	get $cityField() {
		return this.#$cityField;
	}

	get $stateField() {
		return this.#$stateField;
	}

	get $zipCodeField() {
		return this.#$zipCodeField;
	}

	get $dropdown() {
		return this.#$dropdown;
	}

	get $list() {
		return this.#$list;
	}

	getCache(key) {
        return this.cache.get(key) || null;
    }

    getNoResultsOption() {
        return '<li role="option" aria-selected="false"><span>No matching addresses were found.</span></li>';
    }

    async getResults(term) {
        if (!term) {
            return null;
        }

        const cacheKey = term.toLowerCase();
        const cachedData = this.getCache(cacheKey);
        
        if (cachedData) {
            return cachedData;
        }

        params['input'] = term;
		params['sessiontoken'] = this.sessionToken();
		params['state'] = this.getState();

        const url = new URL(this.config.matchingAjax.url);
        url.search = new URLSearchParams(params).toString();

        try {
            const response = await fetch(url, {
                method: this.config.matchingAjax.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                cache: 'no-cache'
            });
        
            const json = await response.json();

            if (!json.code || json.data.status !== 400) {
                this.setCache(cacheKey, json);
            }

            return json;
        } catch (error) {
            console.error(error);
            return [];
        }
    }

	getSessionToken() {
		return null;
	}

	getMatches(resetSessionToken=false) {
        const term = this.filterValue(this.$streetAddress.val());
        this.$streetAddress.val(term);

        clearTimeout(this.timeout);
        this.searchTerm = term;

        if (term.length < this.config.minimumLength) {
            this.hideDropdown();
            this.clearResults();
            return null;
        }

		if (resetSessionToken) {
			this.generateSessionToken();
		}

        this.timeout = setTimeout(() => {
            requestAnimationFrame(() => {
                this.showSearching();
                return this.doSearch(term).then((optionsData) => {
					if (typeof optionsData.status == 'undefined') {
						return null;
					}
					
					if (optionsData.status == 'OK' || optionsData.status == 'ZERO_RESULTS') {
						if (this.searchTerm === term) {
							this.updateResults(optionsData);
						}
						this.hideSearching();
						this.showDropdown();

						return;
					}

					if (optionsData.status === 'REQUEST_DENIED') {
						if (!resetSessionToken) {
							return this.getMatches(true);
						}
						return null;
					}

                    if (['OVER_QUERY_LIMIT', 'INVALID_REQUEST', 'UNKNOWN_ERROR'].includes(optionsData.status)) {
						return null;
					}

                }); 
            });
        }, this.config.delay);
    }

	async getDetailsByPlaceId(placeId) {
		if (!placeId) {
            return null;
        }

        const cacheKey = `place-${placeId}`;
        const cachedData = this.getCache(cacheKey);
        
        if (cachedData) {
            return cachedData;
        }

        params['place_id'] = placeId;
		params['fields'] = 'formatted_address,address_components,adr_address';
		params['sessiontoken'] = this.sessionToken();

        const url = new URL(this.config.detailsAjax.url);
        url.search = new URLSearchParams(params).toString();

        try {
            const response = await fetch(url, {
                method: this.config.matchingAjax.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                cache: 'no-cache'
            });
        
            const json = await response.json();

            if (!json.code || json.data.status !== 400) {
                this.setCache(cacheKey, json);
            }

            return json;
        } catch (error) {
            console.error(error);
            return [];
        }
	}

    set searchTerm(val) {
        this.#searchTerm = val;
        this.$form.trigger('lumeris-address-autocomplete:updated-search-term', {searchTerm: val});
        this.$form.trigger('lumeris-address-autocomplete:updated-search-term:' + this.config.id, {searchTerm: val});
    }

	set sessionToken(val) {
		this.#sessionToken = val;
	}

    setCache(key, value) {
        if (key && value !== undefined) {
            this.cache.set(key, value);

            if (this.cache.size > this.config.cacheLimit) {
                this.cache.delete(this.cache.keys()[0]);
            }
        }
    }

	updateResults(optionsData) {
        this.clearResults();

        if (!optionsData || optionsData.length == 0 || typeof optionsData.predictions == 'undefined' || optionsData.predictions.length == 0) {
            this.$list.append(this.getNoResultsOption());
        } else {
            const options = optionsData.predictions.map(({prediction}) => {
                return `<li role="option" aria-selected="false"><a href="#" data-value="${prediction.place_id}">${prediction.description}</a></li>`;
            }).join('');
          
            this.$list.append(options);
            this.bindListOptions();
        }

        this.$form.trigger('lumeris-address-autocomplete:updated-results', {
            term: this.searchTerm, 
            data: optionsData
        });

        this.$form.trigger('lumeris-address-autocomplete:updated-results:' + this.config.id, {
            term: this.searchTerm, 
            data: optionsData
        });
    }

	generateSessionToken() {
		if (window.crypto && window.crypto.randomUUID) {
			return 'ehi' + window.crypto.randomUUID().slice(3);
		}

		const chars = 'ehixxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx';
		return chars.replace(/[x]/g, (char) => {
			const rand = Math.random() * 16 | 0;
			const v = (char === 'x') ? rand : (rand & 0x3 | 0x8);
			return v.toString(16);
		});
	}

    async doSearch(term) {
        if (!term) {
            return null;
        }

        const data = await this.getResults(term);
        return (typeof this.config.optionsCallback === 'function') ? this.config.optionsCallback(data, this.config) : null;
    }

	showSearching() {
        this.$form.addClass('is-address-autocomplete-searching');
    }

    hideSearching() {
        this.$form.removeClass('is-address-autocomplete-searching');
    }

    showDropdown() {
        this.$streetAddressField.attr('aria-expanded', 'true');
		this.#$dropdown.addClass('is-showing');
    }

    hideDropdown() {
        this.$streetAddressField.attr('aria-expanded', 'false');
		this.#$dropdown.removeClass('is-showing');
    }

    clearResults() {
        this.$list.html('');
    }

	on(event, callback) {
        return this.$form.on(event, callback);
    }

    onStreetAddressInput(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        this.getMatches();
    }

    onStreetAddressKeypress(event) {
        if (!(event.originalEvent instanceof Event) || event.keyCode !== 13) {
            return false;
        }

        this.getMatches();
    }

    onStreetAddressFocus(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'focus' }}));

        if (this.$list.find('li').length !== 0) {
            this.showDropdown();
        }
    }

	async onListOptionClick(event) {
        if (!(event.originalEvent instanceof Event)) {
            return false;
        }

        event.preventDefault();

		this.hideDropdown();

        const $target = $(event.target);
        const placeId  = $target.attr('data-value');

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'select' }}));
        this.$form.trigger('lumeris-address-autocomplete:selected-place', {placeId: placeId});

		const details = await this.getDetailsByPlaceId(placeId);

		if (!details || typeof details.result == 'undefined') {
			return null;
		}

		this.clearResults();

        this.$form.trigger('lumeris-address-autocomplete:selected-place-details', {details: details.result});

		const $fullAddress = $(details.result.adr_address ?? null);

		this.$streetAddressField.val($fullAddress.filter('.street-address').text());
		this.$streetAddress2Field.val($fullAddress.filter('.street-address2').text());
		this.$cityField.val($fullAddress.filter('.locality').text());
		this.$stateField.val($fullAddress.filter('.region').text().toUpperCase());
		this.$zipCodeField.val($fullAddress.filter('.postal-code').text());

		this.$form.trigger('lumeris-address-autocomplete:selected-place-details', {details: details.result});
    }

}